export interface TruemedBenefitsProps {}
export const defaultBenefits = [
	{
		title: 'Save an average of 30%',
		content: 'By using FSA or HSA funds to purchase a Pod, you are spending pre-tax dollars. This means that reimbursements from these accounts are tax-free.',
	},
	{
		title: 'Use it before it expires',
		content: 'When you sign up for an FSA, the IRS mandates that all contributions be used by a specific annual deadline. If not, the remaining funds may be lost.',
	},
	{
		title: 'Invest in your sleep',
		content: 'With the Pod, you can improve and monitor your sleep seamlessly. The Pod is clinically proven to give you up to one hour more of sleep each night.',
	},
]
